import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './app';
import reportWebVitals from './reportWebVitals';
import { Agentation } from "agentation";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <App />
    {process.env.NODE_ENV === "development" && <Agentation />}
  </Provider>
);

reportWebVitals();
